export default __webpack_public_path__ + "static/media/backBtn.19109519.svg";